import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { filterValidCta } from "@qlik/qlik/src/lib/util/helpers";

/**
 * CTAHorizontal component.
 * Renders a section with a title, description, and CTA buttons.
 * @param {Object} data - The data for the component.
 */
const CTAHorizontal = ({ data }) => {
    const { additionalConfiguration, backgroundColor, cardItem, customId } = data ?? {};
    const { title, description, cta } = cardItem ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-25 px-3.75");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    const validCta = filterValidCta(cta);
    return (
        <section
            className={`bg-stone-light py-15 px-3.75 ${sectionColorMapping.bgColor} ${sectionSpacingClassName}`}
            id={customId}
        >
            <div className="container">
                <div
                    // Setting the layout and gap based on the existence of CTA
                    className={`lg:flex justify-center items-center ${!description?.description ? "lg:pl-15" : ""} ${
                        cta === null ? "lg:pl-0" : "gap-7.5"
                    } `}
                >
                    {title && (
                        <h2
                            className={`text-blue text-center min-w-fit lg:text-left text-5xl tracking-tight9 ${
                                validCta.length === 0 ? "lg:min-w-auto" : "lg:min-w-[549px]"
                            }`}
                        >
                            {title}
                        </h2>
                    )}
                    {description?.description && (
                        <p className="body text-blue text-center lg:text-left tracking-tight4">
                            {description.description}
                        </p>
                    )}
                    {validCta.length > 0 && (
                        <div className="flex flex-wrap justify-center mt-4 lg:mt-0 gap-5">
                            {/* Rendering the CTA buttons */}
                            {validCta?.map((button) => (
                                <Cta key={button.id} data={button} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default CTAHorizontal;
